// sorts the values into two arrays, one for emails and one for wildcards
export function sortEmailsAndWildcards(values: string[]): string[] {
  const wildcards: string[] = [];
  const emails: string[] = [];

  for (const value of values) {
    if (value.indexOf('*') > -1 || value.indexOf('?') > -1) {
      wildcards.push(value);
    } else {
      emails.push(value);
    }
  }

  wildcards.sort();
  emails.sort();

  return [...wildcards, ...emails];
}
